import { Box, Typography, useTheme } from "@mui/material";
import { NameField } from "@/modules/lead-page/new/components/sidebar/fields";
import { InfoIcon } from "lucide-react";

interface LeadNameProps {
  name?: string;
  compact?: boolean;
  onPersonClick?: () => void;
  isLoading?: boolean;
  isError?: boolean;
  handleConfirmUpdate: (name?: string) => void;
}

export default function NameSection({
  name,
  compact,
  onPersonClick,
  isLoading,
  isError,
  handleConfirmUpdate,
}: LeadNameProps) {
  const theme = useTheme();

  if (compact) {
    return (
      <Box
        onClick={onPersonClick}
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          gap: theme.nawy.spacing.xxs,
        }}
      >
        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.headline.sm,
            color: name?.trim()
              ? theme.nawy.colors.semantic.text.accent
              : theme.nawy.colors.semantic.text.tertiary,
            wordBreak: "break-word",
            maxWidth: "100%",
          }}
        >
          {name?.trim() || "No Name"}
        </Typography>
        <InfoIcon
          style={{
            width: "19px",
            height: "19px",
            strokeWidth: 3,
            color: theme.nawy.colors.semantic.text.accent,
          }}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%" }}>
      <NameField
        name={name}
        isLoading={isLoading}
        isError={isError}
        handleConfirmUpdate={handleConfirmUpdate}
      />
    </Box>
  );
}
